(() => {
  'use strict';

  const normalize = value => String(value || '').normalize('NFKC').toLocaleLowerCase().replace(/\s+/g, ' ').trim();

  function bindLibrary(library) {
    if (library.dataset.specialtyBound) return;
    library.dataset.specialtyBound = 'true';

    const buttons = [...library.querySelectorAll('[data-specialty-filter]')];
    const cards = [...library.querySelectorAll('[data-specialty-product]')];
    const input = library.querySelector('[data-specialty-search]');
    const counts = [...library.querySelectorAll('[data-specialty-count]')];
    const empties = [...library.querySelectorAll('[data-specialty-empty]')];
    const filters = new Set(buttons.map(button => button.dataset.specialtyFilter));
    const searchable = cards.map(card => normalize(card.dataset.search || card.textContent));
    let category = 'all';

    function hashCategory() {
      try { return decodeURIComponent(location.hash.slice(1)); } catch (_) { return ''; }
    }

    function readCategory() {
      const requested = new URLSearchParams(location.search).get('category');
      const hash = hashCategory();
      return filters.has(requested) ? requested : filters.has(hash) ? hash : 'all';
    }

    function update() {
      const words = normalize(input?.value).split(' ').filter(Boolean);
      let visible = 0;
      cards.forEach((card, index) => {
        const matchesCategory = category === 'all' || card.dataset.category === category;
        const matchesSearch = words.every(word => searchable[index].includes(word));
        card.hidden = !(matchesCategory && matchesSearch);
        if (!card.hidden) visible += 1;
      });
      buttons.forEach(button => {
        const selected = button.dataset.specialtyFilter === category;
        button.setAttribute('aria-pressed', String(selected));
        if (button.getAttribute('role') === 'tab') button.setAttribute('aria-selected', String(selected));
      });
      counts.forEach(count => { count.textContent = String(visible); });
      empties.forEach(empty => { empty.hidden = visible > 0; });
    }

    buttons.forEach(button => button.addEventListener('click', () => {
      const selected = button.dataset.specialtyFilter;
      if (!filters.has(selected)) return;
      category = selected;
      const url = new URL(location.href);
      if (category === 'all') url.searchParams.delete('category');
      else url.searchParams.set('category', category);
      if (filters.has(hashCategory())) url.hash = '';
      history.replaceState(history.state, '', url);
      update();
    }));

    input?.addEventListener('input', update);
    const updateFromLocation = () => {
      if (!library.isConnected) return;
      category = readCategory();
      update();
    };
    window.addEventListener('popstate', updateFromLocation);
    window.addEventListener('hashchange', updateFromLocation);
    (library.closest('.shopify-section') || library).addEventListener('shopify:section:unload', () => {
      window.removeEventListener('popstate', updateFromLocation);
      window.removeEventListener('hashchange', updateFromLocation);
    }, { once: true });
    category = readCategory();
    update();
  }

  function bind(root = document) {
    if (root.matches?.('[data-specialty-library]')) bindLibrary(root);
    root.querySelectorAll('[data-specialty-library]').forEach(bindLibrary);
  }

  bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
